import $ from 'jquery';

import widgetFactory from '../widgetFactory';
import formErrorsService from '../../Services/formErrors';
import formErrorWidget from '../../Widgets/ui/formError';

const widgetName = 'autoFormSubmit';

const widget = widgetFactory(widgetName, {
  options: {
    ajax: true,
    onSubmit: $.noop,
    onAjaxSubmitError: $.noop,
    onAjaxSubmitSuccess: $.noop,
  },

  _create: function () {
    this._super(widgetName);
    this.elements.$form = this.element;
    this.formError = formErrorWidget.create(this.element);

    this.currentFormValues = this.elements.$form.serialize();
    this._addEvents();
  },

  _formValuesHasChanged: function () {
    return this.elements.$form.serialize() !== this.currentFormValues;
  },

  _validateForm: function () {
    var $form = this.elements.$form,
      errors = formErrorsService.getErrors($form),
      isAjax = this.options.ajax;

    if (errors) {
      if (isAjax) {
        this.formError.setErrors(errors);
      }
      this._trigger('onCheckValidityError', null, errors);
      return false;
    }

    return true;
  },

  _addEvents: function () {
    var self = this,
      $form = this.elements.$form,
      submitForm = function (from) {
        var submit = true;
        if (from instanceof Element && !from.name) {
          submit = false;
        }

        if (submit && this._validateForm() && this._formValuesHasChanged()) {
          this.currentFormValues = $form.serialize();
          $form.submit();
        }
      }.bind(this);

    $('select, input[type=checkbox]', $form)
      .not('.js-autoFormSubmitExclude')
      .on('change', function () {
        submitForm(this);
      });

    $('input[type=text], input[type=url], textarea', $form)
      .not('.js-autoFormSubmitExclude')
      .on('blur', function () {
        submitForm(this);
      });

    $('.js-autocomplete', $form).on('autocompleteonchange', function () {
      submitForm();
    });

    $form.on('submit', function (event) {
      if (!self._trigger('onSubmit')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (self.options.ajax) {
        setTimeout(function () {
          $.post($form.attr('action'), $form.serialize())
            .fail(function (jqXHR) {
              var json = jqXHR.responseJSON;

              if (typeof json !== 'undefined') {
                self.formError.setErrors(json);
              }

              self._trigger('onAjaxSubmitError', null, [jqXHR]);
            })
            .done(function (data) {
              self._trigger('onAjaxSubmitSuccess', null, [data]);
            })
            .always(function () {
              $form.removeClass('is-loading');
            });
        }, 50);
        event.preventDefault();
        $form.addClass('is-loading');
      }
    });
  },

  submit: function () {
    this.elements.$form.submit();
  },
});

export default widget;
